export default __webpack_public_path__ + "static/media/toast-tick.f71cdd19.svg";